import React, { Component } from 'react';
import { connect } from 'react-redux';

class Footer extends Component {

  style() {
    return {
      width: '100%',
      margin: 'auto',
      textAlign: 'center',
      bottom: '0',
      height: this.props.footerHeight + 'px',
      display: 'inline-block',
      zIndex: '1',
      backgroundColor: 'black',
      position: 'absolute',
      // padding:'3px', margin:'3px',
    }
  }

  titleStyle() {
    // return { height: this.props.titleHeight + 'px', width:'60%', float:'right'}
    return {
      fontSize: (this.props.titleHeight) + 'px',
    }
  }

  detailStyle() {
    return {
      fontSize:  (this.props.detailHeight ) + 'px',
    }
  }

  copyrightStyle() {
    // return { height: this.props.copyrightHeight + 'px' , width:'20%', float:'right'}
    return { fontSize: (this.props.copyrightHeight ) + 'px' }
  }


  render() {
    return (
      <div style={this.style()}>
        <font style={this.titleStyle()}>
          {this.props.photoTitle}
          <br />
        </font>
        <font style={this.detailStyle()}>
          {this.props.photoDetail}
        </font>
        <br />
        <font style={this.copyrightStyle()}>
          <a href="mailto:krystle@ettaallean.com">krystle@ettaallean.com</a>&nbsp;
            (c) 2011-2019 All Rights Reserved
        </font>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  footerHeight: state.sizing.footerHeight,
  copyrightHeight: state.sizing.footerHeight * 0.15,
  titleHeight: state.sizing.footerHeight * 0.30,
  detailHeight: state.sizing.footerHeight * 0.15,
  photoTitle: state.artScroller.photoTitle,
  photoDetail: state.artScroller.photoDetail,
});

export default connect(mapStateToProps, null)(Footer);




// WEBPACK FOOTER //
// ./src/Footer.js